// components/ActionButtons.js - Updated with role-based visibility
import React from 'react';
import { useAuth } from '../contexts/AuthContext';

const ActionButtons = ({ onAddToDatabase, onExportToCsv, disabled }) => {
    const { canAccessDatabase } = useAuth();

    return (
        <div className="action-buttons">
            {canAccessDatabase() && (
                <button
                    className="action-button database-button"
                    onClick={onAddToDatabase}
                    disabled={disabled}
                >
                    Зберегти в базу
                </button>
            )}

            <button
                className="action-button csv-button"
                onClick={onExportToCsv}
                disabled={disabled}
            >
                Вивантажити CSV
            </button>

            {!canAccessDatabase() && (
                <div className="guest-notice">
                    <small>Гість може збирати й вивантажувати дані, але не зберігати їх у базу.</small>
                </div>
            )}
        </div>
    );
};

export default ActionButtons;